import { requestBuilder } from '../../http/RequestBuilder';
import type { UpdateUserBody, User } from '../types/User';

const useUpdateUser = requestBuilder.mutation<
    User,
    UpdateUserBody,
    { userId: string }
>({
    endpoint: ({ userId }) => `/api/user/${userId}`,
    method: 'PATCH',
});

export default useUpdateUser;
